import React from 'react';
import { View, Modal, Platform } from 'react-native';
import { XStack, YStack, Card, Button } from 'tamagui';
import { Text } from '@constants/Themed';
import { Ionicons, MaterialIcons } from '@expo/vector-icons';
import Slider from '@react-native-community/slider';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';

interface FilterModalProps {
  visible: boolean;
  onClose: () => void;
  radius: number;
  setRadius: (value: number) => void;
  limit: number;
  setLimit: (value: number) => void;
  onApply: () => void;
}

const FilterModal: React.FC<FilterModalProps> = ({
  visible,
  onClose,
  radius,
  setRadius,
  limit,
  setLimit,
  onApply
}) => {
  const theme = themeSelector();

  return (
    <Modal
      visible={visible}
      animationType="slide"
      presentationStyle="pageSheet"
      onRequestClose={onClose}
      transparent={true}
    >
      <View style={{
        flex: 1,
        justifyContent: 'flex-end',
        backgroundColor: 'rgba(0,0,0,0.5)',
      }}>
        <View style={{
          backgroundColor: theme ? 'white' : '#1a1a1a',
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          padding: 20,
          minHeight: 400,
        }}>
          {/* Header */}
          <XStack
            alignItems="center"
            justifyContent="space-between"
            marginBottom={20}
            borderBottomWidth={1}
            borderBottomColor={theme ? 'rgba(0,0,0,0.1)' : 'rgba(255,255,255,0.1)'}
            paddingBottom={16}
          >
            <XStack alignItems="center" gap={12}>
              <View style={{
                width: 40,
                height: 40,
                backgroundColor: 'rgb(90, 192, 234)',
                borderRadius: 20,
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <MaterialIcons name="filter-list" size={24} color="white" />
              </View>
              <Text style={{
                fontSize: 18,
                fontWeight: 'bold',
                color: theme ? 'black' : 'white'
              }}>
                Search Filters
              </Text>
            </XStack>

            <Button
              size="$3"
              circular
              onPress={onClose}
              backgroundColor="transparent"
              borderWidth={0}
            >
              <Ionicons
                name="close"
                size={24}
                color={theme ? 'black' : 'white'}
              />
            </Button>
          </XStack>

          {/* Filters */}
          <YStack gap={24} flex={1}>
            {/* Radius Filter */}
            <Card
              padding={16}
              backgroundColor={theme ? 'rgba(0,0,0,0.02)' : 'rgba(255,255,255,0.05)'}
              borderWidth={1}
              borderColor={theme ? 'rgba(0,0,0,0.1)' : 'rgba(255,255,255,0.1)'}
              borderRadius={12}
            >
              <YStack gap={12}>
                <XStack justifyContent="space-between" alignItems="center">
                  <Text style={{ fontSize: 16, fontWeight: '600', color: theme ? 'black' : 'white' }}>
                    Search Radius
                  </Text>
                  <Text style={{ fontSize: 16, color: 'rgb(90, 192, 234)', fontWeight: 'bold' }}>
                    {radius} km
                  </Text>
                </XStack>
                <Slider
                  style={{ width: '100%', height: 40 }}
                  minimumValue={5}
                  maximumValue={500}
                  step={5}
                  value={radius}
                  onValueChange={setRadius}
                  minimumTrackTintColor="rgb(90, 192, 234)"
                  maximumTrackTintColor={theme ? "#d3d3d3" : "#555"}
                  thumbTintColor="rgb(90, 192, 234)"
                />
                <XStack justifyContent="space-between">
                  <Text style={{ fontSize: 12, color: theme ? '#666' : '#aaa' }}>5 km</Text>
                  <Text style={{ fontSize: 12, color: theme ? '#666' : '#aaa' }}>500 km</Text>
                </XStack>
              </YStack>
            </Card>

            {/* Results Limit Filter */}
            <Card
              padding={16}
              backgroundColor={theme ? 'rgba(0,0,0,0.02)' : 'rgba(255,255,255,0.05)'}
              borderWidth={1}
              borderColor={theme ? 'rgba(0,0,0,0.1)' : 'rgba(255,255,255,0.1)'}
              borderRadius={12}
            >
              <YStack gap={12}>
                <XStack justifyContent="space-between" alignItems="center">
                  <Text style={{ fontSize: 16, fontWeight: '600', color: theme ? 'black' : 'white' }}>
                    Max Results
                  </Text>
                  <Text style={{ fontSize: 16, color: 'rgb(90, 192, 234)', fontWeight: 'bold' }}>
                    {limit}
                  </Text>
                </XStack>
                <Slider
                  style={{ width: '100%', height: 40 }}
                  minimumValue={10}
                  maximumValue={300}
                  step={10}
                  value={limit}
                  onValueChange={setLimit}
                  minimumTrackTintColor="rgb(90, 192, 234)"
                  maximumTrackTintColor={theme ? "#d3d3d3" : "#555"}
                  thumbTintColor="rgb(90, 192, 234)"
                />
                <XStack justifyContent="space-between">
                  <Text style={{ fontSize: 12, color: theme ? '#666' : '#aaa' }}>10</Text>
                  <Text style={{ fontSize: 12, color: theme ? '#666' : '#aaa' }}>300</Text>
                </XStack>
              </YStack>
            </Card>

            <Button
              size="$4"
              backgroundColor="rgb(90, 192, 234)"
              onPress={onApply}
              borderRadius={12}
              marginTop={20}
            >
              <Text style={{ color: 'white', fontWeight: 'bold', fontSize: 16 }}>Apply Filters</Text>
            </Button>
          </YStack>
        </View>
      </View>
    </Modal>
  );
};

export default FilterModal;

